import _ from "lodash";
import { path } from "../../api";
import { restClient, restClientAll } from "../../utils/restClient";
import moment from "moment-timezone";
import { DATE_FORMAT } from "../../utils/utils";

const initialState = {};

export default {
  namespaced: true,
  name: "buy",
  state: _.cloneDeep(initialState),
  actions: {
    async decodeUrlForCart(_, payload = null) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClientAll(
            path.client.decodeLotteries,
            "POST",
            null,
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async fetchLotteries(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.lotteries.base,
            "GET",
            null,
            payload
          );

          if (response && response.data) {
            const now = moment().tz(
              DATE_FORMAT.TIMEZONE || "America/Santo_Domingo"
            );
            let dataToFilter = Array.isArray(response.data)
              ? response.data
              : response.data.data || [];

            const filteredData = dataToFilter.filter((lottery) => {
              const lotteryEndTimeStr = moment
                .tz(
                  lottery.today_end_time,
                  DATE_FORMAT.SERVER_TIME,
                  lottery.timezone || DATE_FORMAT.TIMEZONE
                )
                .tz(DATE_FORMAT.TIMEZONE)
                .format(DATE_FORMAT.MOMENT_TIME);

              const date = moment.tz(
                lotteryEndTimeStr,
                DATE_FORMAT.MOMENT_TIME,
                DATE_FORMAT.TIMEZONE || "America/Santo_Domingo"
              );
              return !date.isBefore(now);
            });

            if (Array.isArray(response.data)) {
              response.data = filteredData;
            } else if (response.data.data) {
              response.data.data = filteredData;
            }
          }

          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async processTicket(_, payload = {}) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.orders.buy,
            "POST",
            payload
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
